import { ISCEService, IWindowService } from 'angular';
import MobileConnectService from '../../common/services/mobile-connect/mobile-connect.service';
import { MobileConnectResponse } from './mobile-connect.model';

/* @ngInject */
export default class MobileConnectController {
  public msisdn: string;
  public redirectUri: string;
  public content: string;

  public onSuccess: (data: { mc: MobileConnectResponse }) => any;
  public onError: (data: { mc: MobileConnectResponse }) => any;

  private windowEventListener: () => any;

  constructor(
    private $window: IWindowService,
    private mobileConnectService: MobileConnectService,
    private $sce: ISCEService
  ) {
    this.windowEventListener = this.onMobileConnect.bind(this);
  }

  public $onInit() {
    this.$window.addEventListener('message', this.windowEventListener, false);
    this.tryLogin();
  }

  public onMobileConnect(event) {
    const mcResponse: MobileConnectResponse = event.data.mobileConnect;
    if (mcResponse && mcResponse.code) {
      this.onSuccess({ mc: mcResponse });
    } else {
      this.onError({ mc: mcResponse });
    }
  }

  public $onDestroy() {
    this.$window.removeEventListener('message', this.windowEventListener);
  }

  private tryLogin() {
    const mobileConnectUrl = this.mobileConnectService.buildUrl(
      this.msisdn,
      this.redirectUri
    );
    this.content = this.$sce.trustAsHtml(
      '<iframe frameborder="0" height="310" width="400" scrolling="no" style="overflow: hidden; margin-top: -10px;" src="' +
        mobileConnectUrl +
        '"></iframe>'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/mobile-connect/mobile-connect.controller.ts